import Home from '.'
import { getServerSideProps } from '../ssr/home'

export default Home
export { getServerSideProps }
